import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_FlowSheet, defaultItem_FlowSheet } from '@app/advisor-content-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_FlowSheet } from '../../../_entity/flow-sheet/ModuleFE_FlowSheet.js';
import { Renderer_FlowSheetHeader } from './renderers/Renderer_FlowSheetHeader/Renderer_FlowSheetHeader.js';
import { Editor_FlowSheet } from '../../editors/Editor_FlowSheet/Editor_FlowSheet.js';
import './Manager_FlowSheet.scss';
import { LL_V_L } from "@nu-art/thunderstorm-frontend";
const Editor_FlowSheet_Wrapper = (props) => _jsxs(LL_V_L, { className: 'manager-flow-sheet', children: [_jsx(Renderer_FlowSheetHeader, { workHubItem: props.workHubItem, renderArgs: props.renderArgs }), _jsx(Editor_FlowSheet, { editable: props.editable, editMode: props.renderArgs.editMode, hideHeader: true })] });
export const Manager_FlowSheet = createWorkHubManager({
    module: ModuleFE_FlowSheet,
    dbDef: DBDef_FlowSheet,
    defaultItem: defaultItem_FlowSheet,
    labelResolver: (flowSheet) => flowSheet.label ?? "New Flow Sheet",
    EditorComponent: Editor_FlowSheet_Wrapper,
});
//# sourceMappingURL=Manager_FlowSheet.js.map